const SHARED_STATE_NAMES = {
    INITIAL: 'edit',
    EDIT: 'edit',
    SUCCESS: 'success',
    SUBMITTING: 'submitting',
    ERROR: 'error'
};
export const AUTOPAY_MACHINE_STATES_NAMES = Object.assign(Object.assign({}, SHARED_STATE_NAMES), { INITIAL: 'manage', MANAGE: 'manage' });
export const ONE_TIME_PAYMENT_MACHINE_STATES_NAMES = Object.assign(Object.assign({}, SHARED_STATE_NAMES), { REVIEW: 'review' });
export const AUTOPAY_ERROR_TYPE_NAMES = {
    ENROLLING: 'enrolling',
    UPDATING: 'updating',
    UNENROLLING: 'unenrolling'
};
export const AUTOPAY_SUCCESS_TYPE_NAMES = {
    ENROLLING: 'enrolling',
    UPDATING: 'updating',
    UNENROLLING: 'unenrolling'
};
export const PAYOFF_MACHINE_STATES_NAMES = Object.assign(Object.assign({}, SHARED_STATE_NAMES), { REVIEW: 'review' });
export const PENDING_MACHINE_STATES_NAMES = {
    PENDING: 'pending'
};
